import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getJAV, updateJAV } from '@/repository/jav';
import { JAV } from '@/model/jav';
import { useStore } from 'vuex';
import { HttpStatusCode } from 'axios';
import JAVInformation from '@/components/disposable/JAVInformation.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateJAVView',
  setup(__props) {

const javUUID = useRoute().params.javUUID as string;
const router = useRouter();
const store = useStore();

let initJAV: JAV = {
	code: '',
	title: '',
	coverImageURL: '',
	link: '',
	actresses: [],
	genres: [],
	isFavorite: false
};

onMounted(async () => {
	const res = await getJAV(javUUID);
	if (res) {
		initJAV = res;
		jav.value = { ...initJAV };
	} else {
		isFound.value = false;
	}
	isLoading.value = false;
});

const isFound = ref(true);
const isLoading = ref(true);
const jav = ref<JAV>({ ...initJAV });
async function saveJAV(isRedirect: boolean, data: JAV) {
	jav.value = data;
	try {
		isLoading.value = true;
		if (jav.value) {
			// DISABLED UPLOAD
			const res = await updateJAV(jav.value);
			if (res.status === HttpStatusCode.Ok) {
				store.dispatch('alert', { type: 'success', message: 'update jav successfully!' });
				if (isRedirect) {
					isLoading.value = false;
					await router.push({ name: 'JAV' });
					return;
				}
				initJAV = { ...jav.value };
			} else if (res.status === HttpStatusCode.BadRequest) {
				throw res.error?.error;
			} else if (res.status === HttpStatusCode.Conflict) {
				throw Error('this jav is already exists!');
			}
		}
		throw Error('image is required');
	} catch (error) {
		store.dispatch('alert', {
			type: 'error',
			message: `${error}` || 'something went wrong, please try again!'
		});
	} finally {
		isLoading.value = false;
	}
}

return (_ctx: any,_cache: any) => {
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock("div", null, [
    (isFound.value)
      ? (_openBlock(), _createBlock(JAVInformation, {
          key: 0,
          jav: jav.value,
          "is-loading": isLoading.value,
          onReset: _cache[0] || (_cache[0] = () => (jav.value = { ..._unref(initJAV) })),
          onSubmit: saveJAV,
          mode: "UPDATE"
        }, null, 8, ["jav", "is-loading"]))
      : (_openBlock(), _createBlock(_component_a_empty, {
          key: 1,
          class: "!text-white my-2 sm:my-4"
        }))
  ]))
}
}

})